<template>
    <app-tabela
        :itens="consultoriasLista"
        :campos="campos"
        :itensPorPagina="itensPorPagina"
        :mostrarFiltro="false"
        :bordered="false"
        :small="false">
        <template slot="nomeConsultoria" slot-scope="data">
            {{data.nomeConsultoria }}
        </template>
        <template slot="situacao" slot-scope="data">
            <app-status
                :status="data.situacao.toUpperCase()"
            ></app-status>
        </template>
        <template slot="botoes">
            <slot name="botoes"></slot>
        </template>
        <template slot="acoes" slot-scope="data">
            <!-- <btn-atualizar-evento
                :tipo="operacao"
                :acao="acao"
                :consultoria="data"
                @atualizarLista="atualizarEventos()"
            ></btn-atualizar-evento>
            <btn-cancelar-evento
                :consultoria="data"
                :acao="acao"
                @atualizarLista="atualizarEventos()">
            </btn-cancelar-evento> -->
            <!-- <documentos-consultoria
                v-if="$temAcessoView('CONV-METACONSUL-00')"
                :consultoria="data"
                @atualizarLista="atualizarConsultorias()">
            </documentos-consultoria> -->
            <metas-consultoria
                v-if="$temAcessoView('CONV-META-CONSUL-00')"
                :evento="data"
                :acao="acao"
                @atualizarLista="atualizarConsultorias()">
            </metas-consultoria>
            <slot name="acoes" v-bind="data"></slot>
        </template>
    </app-tabela>
</template>

<script>
import BtnAtualizarEvento from './BtnAtualizarEvento'
import BtnCancelarEvento from './BtnCancelarEvento'
// import DocumentosConsultoria from './DocumentosConsultoria'
import ConveniosServicos from '../../../ConveniosServicos'
import MetasConsultoria from './metas/MetasConsultoria'

export default {
    components: {
        BtnAtualizarEvento,
        BtnCancelarEvento,
        // DocumentosConsultoria,
        MetasConsultoria
    },

    props: {
        consultorias: {
            type: Array,
            default: () => []
        },

        operacao: {
            type: String,
            default: () => 'D'
        },

        acao: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'nomeConsultoria',
                    label: 'Nome da Consultoria',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'totalPrevisto',
                    label: 'Total Previsto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'totalRealizado',
                    label: 'Total Realizado',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5,
            consultoriasLista: []
        }
    },

    methods: {
        atualizarConsultorias() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterConsultoriasPorAcao(
                this.acao.idAcaoPlanoTrabalho)
                .then(response => {
                if (response) {
                    if (response.success) {
                        this.consultoriasLista = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter os consultorias da ação.',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    mounted(){
        if(this.consultorias){
            this.consultoriasLista = this.consultorias
        }
    },

    watch: {
        consultorias() {
            this.consultoriasLista = this.consultorias
        }
    }
}
</script>
